export const serverUrl = 'http://192.168.1.140:8080';
export const apiUrl = `${serverUrl}/api/v1`;
export const apiPrefix = 'api/v1';
export const timeout = 20000;
